















import {Component, Vue} from "vue-property-decorator";
import OrdersListView from "@/components/Dashboard/Orders/OrdersListView.vue";
import OrderTypes from "@/components/Dashboard/Orders/OrderTypes.vue";

@Component({
  components: {OrderTypes, OrdersListView}
})
export default class Orders extends Vue {
  public title = "سفارش‌های من";

  mounted(){
    window.scrollTo(0,0);
  }
}
